<template>
    <bulk-edit-schedule-modal v-model="showModal"></bulk-edit-schedule-modal>
</template>

<script>
    export default {
        props: {},

        data() {
            return {
                'showModal': true,
            }
        },

        mounted() {

        },

        methods: {},
    }
</script>
